/**
 * Prompt mention tokens (`#kind/slug[:modifier]`) — shared contract for
 * api (save/publish), dashboard (editor serialization), and agents-runtime
 * (rendering pass).
 *
 * Design: aidlc-docs/construction/prompt-mention-editor/technical-design.md §1.
 */
export const MENTION_KINDS = [
    "skill",
    "tool",
    "kb",
    "table",
    "query",
    "context",
    "memory",
    "card",
    "action",
];
export const TABLE_MODIFIERS = ["insert", "update", "write"];
export const MEMORY_MODIFIERS = ["read", "write", "both"];
/**
 * Memory variable temporary-value handling, as a token segment. Maps to the
 * `AgentVariablePermission.temporaryMode` DB enum: `permanent` ⇄ `only_permanent`,
 * `use` ⇄ `use`. Underscore-free so it parses as a token word. (The `ask` enum
 * value still exists DB-side / in the manual variables UI, but is not offered
 * via the mention token — the chip only chooses temporary vs permanent.)
 */
export const MEMORY_TEMP_MODIFIERS = ["permanent", "use"];
/**
 * Memory variable scope, as a token segment. Maps to the per-variable
 * `AgentVariablePermission.visibility` (`MemoryVisibility`): `private` = the
 * agent's own store; `workspace` = the shared workspace pool. Default private.
 */
export const MEMORY_SCOPE_MODIFIERS = ["private", "workspace"];
export const MENTIONS_SNAPSHOT_PARSER_VERSION = 1;
//# sourceMappingURL=types.js.map